export const styles = {
  container: {
    padding: "32px",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alingItens: "center",
    padding: " 32px 12px",
    gap: "24px",
    margin: "0 auto",
    boxShadow: "0px 1px 8px 0px #00000026",
  },
  textoProgresso1: {
    fontSize: "18px",
    fontWeight: "700",
    marginRight: "3px",
    fontFamily: "Nunito",
  },
  textoProgresso2: { fontSize: "16px", fontWeight: 400 },
  porcetagem: { fontSize: 16, fontWeight: 900 },
  dadosGerais: {
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    color: "#1E729F",
  },

  textoDadosPessoais: {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#063F5E",
  },
  selectDadosGerais: {
    width: "230px",
  },

  checkboxText: {
    color: "#063F5",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "22px",
  },
  iconEdit: { marginTop: "2px", marginLeft: "8px" },
  avatar: { width: "144px", height: "144px" },
  fotoButton: { textTransform: "none", height: "50px", width: "201px" },
  containerDadosGerais: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
  },
  containerDadosProfissionais: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "24px",
    width: "100%",
    maxWidth: "900px",
    boxSizing: "border-box !important",
  },
  titleDadosPessoais: {
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#063F5E",
    marginBottom: "4px",
  },
};
